module.exports = __webpack_public_path__ + "img/20210813.cf2a8b33.gif";